// @ts-nocheck
import useAccount from "classes/Accounts/hooks/useAccount";
import Button from "components/Button/Button";
import ErrorsCont from "components/ErrorsCont/ErrorsCont";
import ScrollTable /*, { AsyncScrollTable }*/ from "components/ScrollTable/ScrollTable";
import download_file from "includes/dl_file";
import formatDate from "includes/formatDate";
import { t } from "i18next";
import React, { useState } from "react";
import { getUserProps } from "../../UserProps";
import "./UsersExporter.css";
import { useQueryClient } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { useUsersContext } from "Pages/Contacts/providers/UsersProvider";
import * as Papa from 'papaparse';
import genRequest from "includes/request";
// import genRequest from "includes/request";

export default function UsersExporter(props) {
	const { account } = useAccount();
	// eslint-disable-next-line
	const [Selected] = useState([]);
	const { request, usersToExport, totalRequest, totalUsers } = useUsersContext();
	// const {account} = useAccount();
	const [Cols, setCols] = useState(getUserProps());
	const [Error, setError] = useState([]);
	const old_selected = React.useRef();
	const QCL = useQueryClient();
	const [IsExporting, setIsExporting] = useState(false);

	// React.useEffect(() => {
	// 	// if (this.props.selected === 0 && (old_selected.current?.length !== this.props.selected))
	// 	// 	this.props.setS
	// 	old_selected.current = props?.selected;
	// }, []);

	// const handleSelect = (values) => {
	// 	if (props.setSelected)
	// 		props.setSelected(values);
	// 	else
	// 		setSelected(values);
	// };

	const getSelected = () => {
		if (props.selected?.length) return props.selected;
		let table_select = QCL.getQueryData(["SelectedEmployes"]);
		if (table_select?.length) return table_select;
		if (props.users?.length) return props.users;
		return Selected;
	};

	const fetchDatas = () => {
		return usersToExport === totalUsers ? totalRequest : request;
	};

	const mapEmployeesWithSiteName = (employeesData, sitesData) => {
		// /employees/search returns `results` (kept distinct from `items` to
		// avoid genRequest's auto-unwrap of paginated payloads).
		const rows = employeesData?.results ?? employeesData?.items;
		if (!Array.isArray(rows)) {
			throw new Error('employeesData must contain an array of results');
		}

		if (!Array.isArray(sitesData)) {
			throw new Error('sitesData doit être un tableau');
		}

		const sitesMap = new Map();
		sitesData.forEach(site => {
			if (site.id) {
				sitesMap.set(site.id, site);
			}
		});
		return rows.map(employee => {
			const site = sitesMap.get(employee.siteId);

			// employeeId is aliased once, here, for the "user id" column
			return {
				...employee,
				employeeId: employee.id,
				siteName: employee.siteName ?? site?.name ?? null
			};
		});
	}

	const treat_list = (headers, datas) => {
		const filteredDataArray = datas.map(obj => {
			let filteredObj = {};
			headers.forEach(key => {
				if (obj.hasOwnProperty(key)) {
					filteredObj[key] = obj[key];
				}
			});
			return filteredObj;
		});
		return filteredDataArray;
	};

	const export_selected = async () => {
		let list = getSelected();
		let headers = Cols.map((a) => a.id);
		const sitesOfCompany = await genRequest("sites/company/" + account.companyId);

		if (!list?.length) return setError(t("Contacts.NO_SELECTED_ERROR"));
		if (!headers?.length) return setError(t("Contacts.NO_FIELDS_ERROR"));
		setError(false);
		setIsExporting(true);
		fetchDatas().then(
			(resp) => {
				const usersWithSiteName = mapEmployeesWithSiteName(resp, sitesOfCompany);

				const universalBOM = "\uFEFF";
				let treated = treat_list(headers, usersWithSiteName);
				const csvGenerated = Papa.unparse(treated);
				let name = "Export contacts -" + formatDate(null, "D-M-Y-h-m");
				setIsExporting(false);
				download_file(
					universalBOM + csvGenerated,
					name,
					"text/csv;charset=utf-8;"
				);
			},
			() => {
				setIsExporting(false);
			}
		);
	};

	// let Component = AsyncScrollTable;
	// if (props?.selected || props.users)
	// 	Component = ScrollTable;

	// let items = props?.selected || props.users;
	let selected = getSelected();
	return (
		<div
			className={
				"UsersExporter d-flex flex-column overflow-hidden gap-2 h-100" +
				(props.className ? " " + props.className : "")
			}
		>
			{/* <details className="users-list-details" open>
				<summary>
					<h5 className="d-inline">{selected?.length} {t("Contacts.SELECTED_USERS")}</h5>
				</summary>
				<Component
					className={props.tableClassName}
					queryKey={["Employes", "EmployeOfCompany", account.companyId]}
					queryFn={() => genRequest("employees/company/" + account.companyId)}
					cols={[
						{
							title: t("User.FIRST_NAME"),
							name: "firstName",
							classes: "post-title-cell"
						},
						{
							title: t("User.LAST_NAME"),
							name: "lastName",
							classes: "post-title-cell"
						}
					]}
					sortBy="firstName"
					itemId="employeeId"
					items={[...items]}
					setSelected={handleSelect}
					selected={selected}
					checkbox={true}
				/>
				</details>*/}
			<h6>{t("Contacts.SELECTED", { count: usersToExport })}</h6>
			<hr className="m-1" />

			<UserPropsSelector
				selected={Cols}
				setSelected={setCols}
				tableClassName={props.tableClassName}
			/>
			<ErrorsCont errors={Error} />
			<div>
				<Button
					className={"btn-blue gap-3"}
					onClick={export_selected}
					disabled={IsExporting}
				>
					{t("Contacts.EXPORT")}
					{IsExporting && <FontAwesomeIcon icon={faUpload} />}
				</Button>
			</div>
		</div>
	);
}

const UserPropsSelector = (props) => {
	const { isSup } = useAccount();
	const ExportProps = getUserProps(isSup);
	const { selected, setSelected } = props;

	return (
		<>
			<div>{t("Contacts.EXPORT_FILEDS_MSG")}</div>
			<ScrollTable
				className={"UserPropsSelector " + props.tableClassName}
				itemId="id"
				items={ExportProps}
				cols={[
					{
						title: t("Contacts.EXPORT_FIELD_COL"),
						name: "title",
						sort: false,
					},
				]}
				checkbox={true}
				selected={selected}
				setSelected={setSelected}
				endText={false}
			/>
		</>
	);
};
